export default "__VITE_ASSET__C_9Aii4A__"